import React, { Component } from 'react';

import _ from 'lodash';
import { Message } from 'semantic-grab-ui/src';
import { Col, Icon, Row, Tabs } from 'grab-ui';

import MetricsStatsTable from 'omega-rtc/views/trident-campaigns/metrics/MetricsStatsTable';
import Panel from 'omega-rtc/views/ucd/Panel';
import { REPORTS_KEY } from 'omega-rtc/constants/metrics';
import PerformanceSummarySection from 'omega-rtc/views/ucd/PerformanceSummarySection';
import ProgressiveContainer from 'omega-rtc/components/container/ProgressiveContainer';
import { BenchmarkMap } from 'omega-rtc/types/trident-campaigns';
import BusinessMetricsPanel from 'omega-rtc/views/ucd/BusinessMetricsPanel';
import { formatCampaignMetricsData, constructChartProps } from 'omega-rtc/utils/ucd-utils';
import JourneyBuilder from 'omega-rtc/components/journey-builder/Layout';


import { EquationBarGraph } from 'rtc-widget';


import './UCDHomePage.scss';
import './CampaignDetail.scss';
import './JourneyMetricsPage.scss';

type Props = {
  projectView: Object,
  campaignView: Object,
  tridentCampaignView: Object,
  campaignMetricsViewByDate: Array<Object>,
  businessMetrics: Object,
  campaignBizMetricsColumns: Object,
  subObjective: string,
  isLoadingBenchmark: boolean,
  metricsBenchmark: BenchmarkMap,
  journeyCampaignBusinessMetricsView: Object,
  journeyCampaignProgressView: Object,
};

class JourneyMetricsPage extends Component {
  props: Props

  getMetricsPageUrl(countryID: string, campaignId: string) {
    return `${window.Grab.config.OMEGA_RTC_URI}/campaigns/${countryID}/${campaignId}/metrics`;
  }

  renderNoBenchmarkMessage() {
    return (
      <Message info>
        <p style={{ marginLeft: 30 }}>
          <span style={{ position: 'absolute', left: 25, top: 16 }}> <Icon type="exclamation-circle" /> </span>
          We are collecting data to generate benchmarks for you. Please come back later.
        </p>
      </Message>
    );
  }

  render() {
    const {
      projectView,
      campaignView,
      campaignMetricsViewByDate,
      tridentCampaignView,
      journeyCampaignBusinessMetricsView,
      journeyCampaignProgressView,
      campaignBizMetricsColumns,
      subObjective,
      metricsBenchmark,
      isLoadingBenchmark,
    } = this.props;

    const formattedCampaignMetricViewsByDate = formatCampaignMetricsData(campaignMetricsViewByDate, tridentCampaignView);

    const tridentMetricsPageUrl = this.getMetricsPageUrl(
      _.get(projectView, 'project.countryID'),
      _.get(campaignView, 'campaign.mamCampaignID')
    );
    const campaignMetricsView = campaignMetricsViewByDate[0];
    const lastUpdatedDate = _.get(campaignMetricsView, 'lastUpdated', {});

    const { objective } = campaignView;
    const nodes = _.get(tridentCampaignView, 'campaign.nodes', {});
    console.log(journeyCampaignProgressView);
    const totalCount = _.get(journeyCampaignProgressView, 'metrics[1].processed_count', 0) || _.get(journeyCampaignProgressView, 'metrics[2].processed_count', 0); // get total count from schedule or 1st comm node
    const nodesWithData = Object.entries(nodes).reduce((accumulator, [key, node]) => {
      const metrics = _.get(journeyCampaignProgressView, `metrics.${key}`);
      return {
        ...accumulator,
        [key]: {
          ...node,
          data: {
            ...node.data,
            ...metrics,
            totalCount,
          },
        },
      };
    }, {});

    return (
      <div className="project-performance-metrics campaign-performance-metrics">
        {!_.isEmpty(journeyCampaignBusinessMetricsView) &&
          <BusinessMetricsPanel
            objective={objective}
            subObjective={subObjective}
            campaignBizMetricsColumns={campaignBizMetricsColumns}
            businessMetrics={journeyCampaignBusinessMetricsView.business}
          />
        }
        <Tabs
          defaultActiveKey={'comms_1'}
          className={'journey-performance'}
        >
          <Tabs.TabPane
            key={'summary'}
            tab={'Summary'}
          >
            <JourneyBuilder isView data={nodesWithData} showMetrics />
          </Tabs.TabPane>
          {
            Object.entries(formattedCampaignMetricViewsByDate).map(([commName, metricWeeks]) => (
              <Tabs.TabPane
                key={commName}
                tab={commName}
              >
                <Panel title={'Communication content'}>
                  <Row className="project-page-metrics-topbar campaign-page-metrics-topbar">
                    <table>
                      <tr>
                        <td>
                          <span>Type</span>
                          <p>{metricWeeks.templateContent.type}</p>
                        </td>
                        <td>
                          <span>Title</span>
                          <p>{metricWeeks.templateContent.templateName}</p>
                        </td>
                      </tr>
                    </table>
                  </Row>
                </Panel>
                <Panel title={'Communication Metrics'} reports={_.get(campaignMetricsView, REPORTS_KEY)}>
                  <Row style={{ marginTop: 0 }} className="">
                    <Col span={24}>
                      <div style={{ margin: '32px 0' }}>
                        <EquationBarGraph {...constructChartProps(metricWeeks.summary)} />
                      </div>
                      <p className={'detail-statistic-hyperlink'}><a
                        href={tridentMetricsPageUrl}
                        target={'_blank'}
                      >View in-depth
                        statistic</a></p>
                      <div>
                        <ProgressiveContainer
                          style={{ height: 'auto', minHeight: 45 }} message={'Loading Benchmarks ...'}
                          isLoading={isLoadingBenchmark}
                        >
                          {!_.isEmpty(metricsBenchmark) ?
                            <PerformanceSummarySection metricsStat={metricWeeks.comms} metricsBenchmark={metricsBenchmark} />
                            : this.renderNoBenchmarkMessage()
                          }
                        </ProgressiveContainer>
                        <MetricsStatsTable
                          headerTitle={'Sent Date'} metricsStat={metricWeeks.comms}
                          nodeType={'scenarios'} lastUpdatedDate={lastUpdatedDate}
                          metricsBenchmark={metricsBenchmark}
                        />
                      </div>
                    </Col>
                  </Row>
                </Panel>
              </Tabs.TabPane>
            ))
          }
        </Tabs>

      </div>
    );
  }
}

export default JourneyMetricsPage;
